import { Nav } from "../components/Nav";
import { Hero } from "../components/Hero";
import { WorkSections } from "../components/WorkSections";
import { Contact } from "../components/Contact";
import { useReveal } from "../hooks/useReveal";

export default function Landing() {
  useReveal();

  return (
    <main data-testid="landing-root" className="relative w-full bg-background text-foreground">
      <Nav />
      <Hero />
      <WorkSections />
      <Contact />
    </main>
  );
}
